
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.313 6c0-.082-.055-.164-.11-.219-.055-.054-.137-.11-.219-.11h-1.53v-1.53c0-.082-.056-.164-.11-.22-.055-.054-.137-.108-.219-.108H5.25a.347.347 0 00-.246.109.31.31 0 00-.082.219v1.53H3.39a.347.347 0 00-.246.11.31.31 0 00-.083.219v.875c0 .11.028.191.083.246.054.055.136.082.246.082h1.53v1.531c0 .11.028.192.083.246.055.055.137.082.246.082h.875a.31.31 0 00.219-.082.347.347 0 00.11-.246v-1.53h1.53a.31.31 0 00.22-.083.347.347 0 00.108-.246V6zm5.496 7.793a.66.66 0 00.191-.465c0-.164-.082-.328-.191-.465l-2.735-2.734c-.136-.11-.3-.191-.465-.191h-.437a5.545 5.545 0 001.203-3.5c0-1.04-.273-1.97-.766-2.844a5.822 5.822 0 00-2.078-2.078C7.656 1.023 6.727.75 5.687.75a5.78 5.78 0 00-2.87.766A5.54 5.54 0 00.765 3.594C.246 4.469 0 5.398 0 6.438c0 1.039.246 1.996.766 2.87a5.28 5.28 0 002.05 2.051c.875.52 1.832.766 2.872.766 1.312 0 2.46-.383 3.5-1.203v.437c0 .192.054.356.19.465l2.735 2.735c.11.136.274.191.465.191a.64.64 0 00.465-.191l.766-.766zM9.406 6.438a3.58 3.58 0 01-.52 1.859 3.78 3.78 0 01-1.34 1.367 3.71 3.71 0 01-1.859.492 3.566 3.566 0 01-1.859-.492 3.646 3.646 0 01-1.367-1.367 3.566 3.566 0 01-.492-1.86c0-.656.164-1.285.492-1.859a3.78 3.78 0 011.367-1.34 3.587 3.587 0 011.86-.52c.656 0 1.285.192 1.859.52a3.927 3.927 0 011.34 1.34c.328.574.52 1.203.52 1.86z"}})])
          )
        }
      }
    